import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetActualProductName,
  IsLoadingDataCriteria,
  GetSuccessCriteriaList,
  loadSuccessCriteriaListData,
  setActualProductName,
  setIsContentEditable,
  GetIsContentEditable,
  SelectSuccessCriteriaStatuses,
  GetIsProductActive,
  setIsProductActive,
  SelectIsStatusLoaded,
  loadSuccessCriteriaStatuses,
  GetActualProductId,
  SelectNeedCriteriaRefresh,
  setIsLoadingDataCriteria,
} from "../redux/reducers/successCriteria.reducer";
import { SuccessCriteriaService } from "../services/successCriteria";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { useNavigate } from "react-router";
import { ROUTE_DELETE_PRODUCT_PAGE } from "../../SharedModule/utils/constants";

export const useSuccessCriteria = (productId: number) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const actualProductName = useSelector(GetActualProductName);
  const actualProductId = useSelector(GetActualProductId);
  const isContentEditable = useSelector(GetIsContentEditable);
  const isProductActive = useSelector(GetIsProductActive);
  const isLoadingDataCriteria = useSelector(IsLoadingDataCriteria);
  const successCriteriaList = useSelector(GetSuccessCriteriaList);
  const successCriteriaStatuses = useSelector(SelectSuccessCriteriaStatuses);
  const isStatusLoaded = useSelector(SelectIsStatusLoaded);
  const needCriteriaRefresh = useSelector(SelectNeedCriteriaRefresh);

  const loadSuccessCriteriaInfo = useCallback(async () => {
    if (
      !actualProductId ||
      actualProductId !== actualProductId ||
      needCriteriaRefresh
    ) {
      try {
        if (!isStatusLoaded) {
          const successCriteriaStatuses =
            await SuccessCriteriaService.getSuccessCriteriaStatus();
          dispatch(loadSuccessCriteriaStatuses(successCriteriaStatuses));
        }

        const successCriteriaData =
          await SuccessCriteriaService.getSuccessCriteriaList(productId)
            .then((data) => {
              return data;
            })
            .catch((error) => {
              return error.response || error.message;
            });

        let action: any = {
          successCriteriaList: successCriteriaData.data.errors
            ? successCriteriaData.data
            : successCriteriaData.data.successCriteriaList,
          productId: productId,
        };

        dispatch(loadSuccessCriteriaListData(action));
        dispatch(setActualProductName(successCriteriaData.data.productName));
        dispatch(
          setIsContentEditable(successCriteriaData.data.isContentEditable)
        );
        dispatch(setIsProductActive(successCriteriaData.data.isProductActive));
      } catch (error: any) {
        dispatch(setIsLoadingDataCriteria(false));
        dispatch(
          addToast({
            mode: "error",
            message: error?.message
              ? `Error: ${error.message}`
              : "Something wrong happened while getting success criteria information.",
          })
        );
        navigate(ROUTE_DELETE_PRODUCT_PAGE);
        return;
      }
    } else {
      dispatch(setIsLoadingDataCriteria(false));
    }
  }, [dispatch, productId, needCriteriaRefresh]);

  useEffect(() => {
    loadSuccessCriteriaInfo();
  }, [loadSuccessCriteriaInfo]);

  return {
    actualProductName,
    isContentEditable,
    isProductActive,
    isLoadingDataCriteria,
    successCriteriaList,
    successCriteriaStatuses,
  };
};
